var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0231 10.355L9.97509 14.403C9.43829 13.8662 9.13672 13.1381 9.13672 12.379C9.13672 12.0031 9.21076 11.6309 9.3546 11.2836C9.49845 10.9363 9.70929 10.6208 9.97509 10.355C10.2409 10.0892 10.5564 9.87833 10.9037 9.73449C11.251 9.59064 11.6232 9.5166 11.9991 9.5166C12.7582 9.5166 13.4863 9.81817 14.0231 10.355Z",
    stroke: "#758295",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4173 7.65004C15.089 6.64808 13.5709 6.10156 11.9996 6.10156C9.32017 6.10156 6.82287 7.6804 5.08463 10.413C4.40148 11.4833 4.40148 13.2822 5.08463 14.3525C5.68428 15.2937 6.38262 16.1059 7.14167 16.7587M9.28221 18.0947C10.1475 18.459 11.066 18.6564 11.9996 18.6564C14.6791 18.6564 17.1764 17.0775 18.9146 14.3449C19.5978 13.2746 19.5978 11.4757 18.9146 10.4054C18.6642 10.0107 18.3909 9.63877 18.11 9.2896",
    stroke: "#758295",
    strokeWidth: 1.13859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.808 12.9389C14.6996 13.497 14.427 14.0099 14.025 14.4119C13.623 14.8139 13.1101 15.0865 12.552 15.1949M9.976 14.4029L4 20.3789M20 4.37891L14.024 10.3549",
    stroke: "#758295",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.4d631e72aab7097798b906cb2f66f23f.svg";
export { ForwardRef as ReactComponent };